import React from 'react';
import PropTypes from 'prop-types';

import ScrollPagination from './Components/ScrollPagination';
import { testAttributes, defaultAttributes } from './Constants';
import * as styles from './GridContainer.module.scss';

const GridContainer = ({  
    containerId = defaultAttributes.containerId,
    ...props
}) => 
    (
        <div
            className={`${styles.gridPostContainer}`}
            data-testid={testAttributes.GRID_POST_CONTAINER}
            id={containerId}
        >
            <ScrollPagination {...props} />
        </div>
    );

GridContainer.propTypes = {
    /** queryArgs (Post, total_found) */
    queryArgs: PropTypes.shape({
        total_found: PropTypes.number,
        Post: PropTypes.array
    }).isRequired,
    /** number of cards per grid */
    gridLimit: PropTypes.number,
    /** HTML element ID for grid container */
    containerId: PropTypes.string,
    /** showControl boolean to show see more button default(true) */
    showControl: PropTypes.bool,
};

export default GridContainer;
export const {containerId} = defaultAttributes;